import React from 'react';

const Guarantee = () => {
  return (
    <section className="guarantee-section">
      <div className="guarantee-background-effects"></div>
      <div className="container">
        <div className="guarantee-wrapper">
          <div className="guarantee-emblem">
            <img 
              src="/images/Selo_de_Garantia_de_7_Dias.png" 
              alt="Selo de Garantia de 7 Dias"
              className="guarantee-seal"
            />
          </div>
          
          <div className="guarantee-content">
            <h2 className="guarantee-title">AINDA ESTÁ NA DÚVIDA?</h2>
            <div className="guarantee-text">
              <p>
                Não tem dúvida, o Curso Expert em Henna simplesmente funciona. A prova disso são as milhares de alunas com resultados incríveis e que tiveram suas vidas transformadas.
              </p>
              <p>
                Mas se você ainda tem alguma dúvida, vou permitir que você experimente por <strong>7 dias</strong> e caso você não goste ou não veja nenhum resultado, basta me enviar um e-mail durante esse período que devolvo todo o valor que você pagou.
              </p>
              <p>
                O meu objetivo é adicionar <strong>Valor Real</strong> à sua vida, ensinando técnicas eficazes para você se tornar uma <strong>Designer de Sucesso</strong>.
              </p>
              <p className="guarantee-highlight">
                O único risco que você corre é de estar aqui e se tornar uma Expert em Sobrancelhas e ter Sucesso. Simples assim!
              </p>
            </div>
            <a href="https://pay.kiwify.com.br/TXv8v09" target="_blank" rel="noopener noreferrer" className="guarantee-cta-button">
              Sim, quero começar agora!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guarantee;

